import { hasPricingAuthority } from '@util/PricingRights';
import Authority from '@app/model/authentication/Authority';
import Principal from '@app/model/authentication/Principal';
import isEmpty from 'lodash/isEmpty';
import ACLAuthority from '@app/model/profile/ACLAuthority';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import Domain from '@app/model/_common/Domain';
import DomainAuthority from '@app/model/profile/DomainAuthority';

class SecurityHelper {
	static hasPricingAuthority = hasPricingAuthority;
	static hasAnyAuthority(principal: Principal | undefined, hasAnyAuthority: Authority[] | undefined) {
		if (!SecurityHelper.isAuthenticated(principal) || isEmpty(principal!.authorities || isEmpty(hasAnyAuthority))) return false;
		// @ts-ignore
		return hasAnyAuthority.some(a => principal.authorities.includes(a));
	};

	static hasAclAuthority(principal: Principal | undefined, companyHotel: CompanyHotel | undefined, aclAuthority: ACLAuthority) {
		if (!SecurityHelper.isAuthenticated(principal) || !companyHotel) return false;
		// @ts-ignore
		return (principal?.accessControl ?? []).some(acl => acl.companyHotelId === companyHotel.id && acl.domainAuthorities.some(da=>da.authority == aclAuthority));
	};

	static hasAnyAclAuthority(principal: Principal | undefined, aclAuthority: ACLAuthority) {
		if (!SecurityHelper.isAuthenticated(principal)) return false;
		// @ts-ignore
		return (principal?.accessControl ?? []).some(acl => acl.domainAuthorities.some(da=>da.authority == aclAuthority));
	};

	static isAuthenticated(principal: Principal | undefined) {
		return !!principal && principal.isEnabled;
	}


	static hasAnyCompanyHotelDomainEnabled(principal: Principal | undefined, domain: Domain) {
		if (!SecurityHelper.isAuthenticated(principal)) return false;
		return (principal!.accessControl ?? []).some(acl => acl.domainAuthorities.some((da: DomainAuthority) => da.domain === domain && da.authority != ACLAuthority.NONE));
	}

	static hasCompanyHotelDomainAuthority(principal: Principal | undefined, companyHotel: CompanyHotel | undefined, domain: Domain) {
		if (!SecurityHelper.isAuthenticated(principal) || !companyHotel) return false;
		// As in the backend (PrincipalWithACL.hasAccess), an admin reaches every hotel of the company without an own row.
		if (SecurityHelper.hasAnyAuthority(principal, [Authority.ADMIN])) return true;
		return (principal!.accessControl ?? []).some(acl =>
			acl.companyHotelId === companyHotel.id &&
			acl.domainAuthorities.some(da => da.domain === domain && da.authority !== ACLAuthority.NONE));
	}

}

export default SecurityHelper;
